// @generated by protoc-gen-es v2.10.0 with parameter "target=ts"
// @generated from file auth/auth_respones.proto (package com.gem.vcs.contract, syntax proto3)

/* eslint-disable */
import type { Message } from '@bufbuild/protobuf';
import type { GenFile, GenMessage } from '@bufbuild/protobuf/codegenv2';
import { fileDesc, messageDesc } from '@bufbuild/protobuf/codegenv2';

/**
 * Describes the file auth/auth_respones.proto.
 */
export const file_auth_auth_respones: GenFile =
  /*@__PURE__*/
  fileDesc(
    'ChhhdXRoL2F1dGhfcmVzcG9uZXMucHJvdG8SFGNvbS5nZW0udmNzLmNvbnRyYWN0Ik4KDUxvZ2luUmVzcG9uc2USNQoHc3VjY2VzcxgBIAEoCzIiLmNvbS5nZW0udmNzLmNvbnRyYWN0LkxvZ2luU3VjY2Vzc0gAQgYKBHR5cGUiOQoMTG9naW5TdWNjZXNzEhMKC2FjY2Vzc1Rva2VuGAEgASgJEhQKDHJlZnJlc2hUb2tlbhgCIAEoCSJcChRSZWZyZXNoVG9rZW5SZXNwb25zZRI8CgdzdWNjZXNzGAEgASgLMikuY29tLmdlbS52Y3MuY29udHJhY3QuUmVmcmVzaFRva2VuU3VjY2Vzc0gAQgYKBHR5cGUiQAoTUmVmcmVzaFRva2VuU3VjY2VzcxITCgthY2Nlc3NUb2tlbhgBIAEoCRIUCgxyZWZyZXNoVG9rZW4YAiABKAlCGAoUY29tLmdlbS52Y3MuY29udHJhY3RQAWIGcHJvdG8z'
  );

/**
 * @generated from message com.gem.vcs.contract.LoginResponse
 */
export type LoginResponse = Message<'com.gem.vcs.contract.LoginResponse'> & {
  /**
   * @generated from oneof com.gem.vcs.contract.LoginResponse.type
   */
  type:
    | {
        /**
         * @generated from field: com.gem.vcs.contract.LoginSuccess success = 1;
         */
        value: LoginSuccess;
        case: 'success';
      }
    | { case: undefined; value?: undefined };
};

/**
 * Describes the message com.gem.vcs.contract.LoginResponse.
 * Use `create(LoginResponseSchema)` to create a new message.
 */
export const LoginResponseSchema: GenMessage<LoginResponse> =
  /*@__PURE__*/
  messageDesc(file_auth_auth_respones, 0);

/**
 * @generated from message com.gem.vcs.contract.LoginSuccess
 */
export type LoginSuccess = Message<'com.gem.vcs.contract.LoginSuccess'> & {
  /**
   * @generated from field: string accessToken = 1;
   */
  accessToken: string;

  /**
   * @generated from field: string refreshToken = 2;
   */
  refreshToken: string;
};

/**
 * Describes the message com.gem.vcs.contract.LoginSuccess.
 * Use `create(LoginSuccessSchema)` to create a new message.
 */
export const LoginSuccessSchema: GenMessage<LoginSuccess> =
  /*@__PURE__*/
  messageDesc(file_auth_auth_respones, 1);

/**
 * @generated from message com.gem.vcs.contract.RefreshTokenResponse
 */
export type RefreshTokenResponse = Message<'com.gem.vcs.contract.RefreshTokenResponse'> & {
  /**
   * @generated from oneof com.gem.vcs.contract.RefreshTokenResponse.type
   */
  type:
    | {
        /**
         * @generated from field: com.gem.vcs.contract.RefreshTokenSuccess success = 1;
         */
        value: RefreshTokenSuccess;
        case: 'success';
      }
    | { case: undefined; value?: undefined };
};

/**
 * Describes the message com.gem.vcs.contract.RefreshTokenResponse.
 * Use `create(RefreshTokenResponseSchema)` to create a new message.
 */
export const RefreshTokenResponseSchema: GenMessage<RefreshTokenResponse> =
  /*@__PURE__*/
  messageDesc(file_auth_auth_respones, 2);

/**
 * @generated from message com.gem.vcs.contract.RefreshTokenSuccess
 */
export type RefreshTokenSuccess = Message<'com.gem.vcs.contract.RefreshTokenSuccess'> & {
  /**
   * @generated from field: string accessToken = 1;
   */
  accessToken: string;

  /**
   * @generated from field: string refreshToken = 2;
   */
  refreshToken: string;
};

/**
 * Describes the message com.gem.vcs.contract.RefreshTokenSuccess.
 * Use `create(RefreshTokenSuccessSchema)` to create a new message.
 */
export const RefreshTokenSuccessSchema: GenMessage<RefreshTokenSuccess> =
  /*@__PURE__*/
  messageDesc(file_auth_auth_respones, 3);
